import { locale } from "./../../assets/const";
import contents_es_ES from "./contents.es_ES";
import contents_es_CA from "./contents.es_CA";
import contents_en_GB from "./contents.en_GB";

import { catalanPublicWebUrl, englishPublicWebUrl } from "../../assets/const";

class TranslationServiceSingleton {
  constructor() {
    switch (locale) {
      case "en_GB":
        this.contents = contents_en_GB;
        break;
      case "es_CA":
        this.contents = contents_es_CA;
        break;
      case "es_ES":
        this.contents = contents_es_ES;
        break;
      default:
        const domain = document.location.origin;
        switch (domain) {
          case catalanPublicWebUrl:
            this.contents = contents_es_CA;
            break;
          case englishPublicWebUrl:
            this.contents = contents_en_GB;
            break;
          default:
            this.contents = contents_es_ES;
        }
    }
  }

  get(path) {
    return getByString(this.contents, path);
  }

  currentLangForScore() {
    switch (locale) {
      case "en_GB":
        return "en";
      case "es_CA":
        return "ca";
      case "es_ES":
        return "es";
      // eslint-disable-next-line no-case-declarations
      default:
        const domain = document.location.origin;
        switch (domain) {
          case catalanPublicWebUrl:
            return "ca";
          case englishPublicWebUrl:
            return "en";
          default:
            return "es";
        }
    }
  }
}

function getByString(o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  const a = s.split(".");
  for (let i = 0, n = a.length; i < n; ++i) {
    const k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
}

const TranslationService = new TranslationServiceSingleton();

export default TranslationService;



// WEBPACK FOOTER //
// ./src/services/translation/TransationService.jsx